import {validarCURP, validarEmail, validarEntrada, validarNombre, validarTelefono} from "./Validaciones";
import {updateChatbotState} from "./Utils";

export const iniciarVentaDebug = (setVentaState, setState, createChatBotMessage) => {
    const datosPredefinidos = {
        nombre: "MARIA DELREFUGIO CARREON REYES",
        nombre_calle: "DE LAS ROSAS",
        numero_exterior: "109",
        colonia: "SPRINGFIELD",
        codigo_postal: "34167",
        telefono: "6181683219",
        email: "maria@icloud.com",
        curp: "RCDM850101HDFRRL05",
        paquete:"Izzi80 + Izzitv HD por $589"
    };

    // Establece la etapa "confirmarDatos" para mostrar el resumen con opciones de confirmación
    setVentaState({etapa: "confirmarDatos", datos: datosPredefinidos});

    const mensajeResumen = createChatBotMessage(
        "Aquí tienes el resumen del cliente:",
        {widget: "resumenVenta", payload: datosPredefinidos}
    );
    updateChatbotState(setState, mensajeResumen);

    // Mensaje con las opciones de confirmación
    const mensajeOpciones = createChatBotMessage(
        "¿Deseas continuar con la venta?",
        {widget: "widgetOpcionesConfirmarSeguirVenta", payload: datosPredefinidos}
    );
    updateChatbotState(setState, mensajeOpciones);
};

// Inicia el flujo de venta
export const iniciarVenta = (setVentaState, setState, createChatBotMessage) => {
    setVentaState({etapa: "nombreCliente", datos: {}});
    const botMessage = createChatBotMessage(
        "Claro, iniciemos! 😊\n¿Podrías proporcionarme el nombre completo del cliente?"
    );
    updateChatbotState(setState, botMessage);
};

export const manejarFlujoVenta = (
    userMessage,
    ventaState,
    setVentaState,
    setState,
    createChatBotMessage
) => {
    const {etapa, datos} = ventaState;

    switch (etapa) {
        case "nombreCliente":
            if (
                !validarEntrada(
                    userMessage,
                    validarNombre,
                    "El nombre debe incluir al menos un nombre y un apellido. Por favor, vuelve a intentarlo.",
                    "confirmarNombre",
                    "nombre",
                    setVentaState,
                    ventaState,
                    setState,
                    createChatBotMessage
                )
            )
                return;

            const mensajeNombre = createChatBotMessage(
                `¿Quieres confirmar el nombre ${userMessage}?`,
                {widget: "opcionesConfirmar"}
            );
            updateChatbotState(setState, mensajeNombre);
            break;

        case "confirmarNombre":
            if (userMessage.toLowerCase() === "sí") {
                // Pasamos a capturar el domicilio
                setVentaState({etapa: "domicilioCliente", datos});
                const mensajeDomicilio = createChatBotMessage(
                    "Por favor, proporciona el domicilio del cliente en el siguiente formato:\n\n**Calle, Número, Colonia, Código Postal**"
                );
                updateChatbotState(setState, mensajeDomicilio);
            } else {
                setVentaState({etapa: "nombreCliente", datos});
                const mensajeEditarNombre = createChatBotMessage(
                    "Por favor, proporciona el nombre completo del cliente nuevamente."
                );
                updateChatbotState(setState, mensajeEditarNombre);
            }
            break;

        case "domicilioCliente":
            // Aquí se espera el domicilio en formato "Calle, Número, Colonia, Código Postal"
            const partes = userMessage.split(',');
            if (partes.length < 4) {
                const mensajeFormato = createChatBotMessage(
                    "El formato del domicilio es incorrecto. Por favor, escribe la dirección en el siguiente formato:\n**Calle, Número, Colonia, Código Postal**"
                );
                updateChatbotState(setState, mensajeFormato);
                return;
            }
            const nombreCalle = partes[0].trim();
            const numeroExterior = partes[1].trim();
            const colonia = partes[2].trim();
            const codigoPostal = partes[3].trim();

            // Actualizamos el estado con los datos extraídos
            setVentaState({
                etapa: "confirmarDomicilio",
                datos: {
                    ...ventaState.datos,
                    nombre_calle: nombreCalle,
                    numero_exterior: numeroExterior,
                    colonia: colonia,
                    codigo_postal: codigoPostal
                }
            });

            // Mostrar mensaje de confirmación con los datos extraídos
            const mensajeDomicilioConfirmar = createChatBotMessage(
                `¿Quieres confirmar la siguiente dirección?\nCalle: ${nombreCalle}\nNúmero: ${numeroExterior}\nColonia: ${colonia}\nCódigo Postal: ${codigoPostal}`,
                {widget: "opcionesConfirmar"}
            );
            updateChatbotState(setState, mensajeDomicilioConfirmar);
            break;


        case "confirmarDomicilio":
            if (userMessage.toLowerCase() === "sí") {
                setVentaState({etapa: "telefonoCliente", datos});
                const mensajeTelefono = createChatBotMessage(
                    "¿Podrías proporcionar un número telefónico del cliente?"
                );
                updateChatbotState(setState, mensajeTelefono);
            } else {
                // Si se rechaza, se regresa a pedir el domicilio nuevamente
                setVentaState({etapa: "domicilioCliente", datos});
                const mensajeEditarDomicilio = createChatBotMessage(
                    "Por favor, escribe el domicilio nuevamente en el formato:\n**Calle, Número, Colonia, Código Postal**"
                );
                updateChatbotState(setState, mensajeEditarDomicilio);
            }
            break;

        case "telefonoCliente":
            if (
                !validarEntrada(
                    userMessage,
                    validarTelefono,
                    "El número telefónico debe contener 10 dígitos. Por favor, verifica e intenta nuevamente.",
                    "confirmarTelefono",
                    "telefono",
                    setVentaState,
                    ventaState,
                    setState,
                    createChatBotMessage
                )
            )
                return;

            const mensajeTelefonoConfirmar = createChatBotMessage(
                `¿Quieres confirmar el número ${userMessage}?`,
                {widget: "opcionesConfirmar"}
            );
            updateChatbotState(setState, mensajeTelefonoConfirmar);
            break;

        case "confirmarTelefono":
            if (userMessage.toLowerCase() === "sí") {
                setVentaState({etapa: "emailCliente", datos});
                const mensajeEmail = createChatBotMessage(
                    "¿Podrías proporcionar el correo electrónico del cliente?"
                );
                updateChatbotState(setState, mensajeEmail);
            } else {
                setVentaState({etapa: "telefonoCliente", datos});
                const mensajeEditarTelefono = createChatBotMessage(
                    "Por favor, proporciona el número telefónico nuevamente."
                );
                updateChatbotState(setState, mensajeEditarTelefono);
            }
            break;

        case "emailCliente":
            if (
                !validarEntrada(
                    userMessage,
                    validarEmail,
                    "El correo electrónico proporcionado no es válido. Por favor, escribe un correo en formato válido (ejemplo@correo.com).",
                    "confirmarEmail",
                    "email",
                    setVentaState,
                    ventaState,
                    setState,
                    createChatBotMessage
                )
            )
                return;

            const mensajeEmailConfirmar = createChatBotMessage(
                `¿Quieres confirmar el correo ${userMessage}?`,
                {widget: "opcionesConfirmar"}
            );
            updateChatbotState(setState, mensajeEmailConfirmar);
            break;

        case "confirmarEmail":
            if (userMessage.toLowerCase() === "sí") {
                // Puedes continuar con más datos (por ejemplo, CURP o directamente pasar al resumen)
                // En este ejemplo continuaremos pidiendo la CURP
                setVentaState({etapa: "curpCliente", datos});
                const mensajeCURP = createChatBotMessage(
                    "Por último, ingresa la CURP del cliente."
                );
                updateChatbotState(setState, mensajeCURP);
            } else {
                setVentaState({etapa: "emailCliente", datos});
                const mensajeEditarEmail = createChatBotMessage(
                    "Por favor, escribe el correo electrónico nuevamente."
                );
                updateChatbotState(setState, mensajeEditarEmail);
            }
            break;

        case "curpCliente":
            // Validar la CURP (se supone que tienes la función validarCURP)
            if (
                !validarEntrada(
                    userMessage,
                    validarCURP,  // Función que valida la CURP
                    "La CURP no es válida. Asegúrate de que tenga 18 caracteres alfanuméricos en mayúsculas.",
                    "confirmarCURP",
                    "curp",
                    setVentaState,
                    ventaState,
                    setState,
                    createChatBotMessage
                )
            )
                return;

            const mensajeCURPConfirmar = createChatBotMessage(
                `¿Quieres confirmar la CURP ${userMessage}?`,
                {widget: "opcionesConfirmar"}
            );
            updateChatbotState(setState, mensajeCURPConfirmar);
            break;


        case "confirmarCURP":
            if (userMessage.toLowerCase() === "sí") {
                setVentaState({etapa: "confirmarDatos", datos});
                // Mensaje con el resumen del cliente usando el widget de resumen
                const mensajeResumen = createChatBotMessage(
                    "Resumen del cliente:",
                    {widget: "resumenVenta", payload: datos}
                );
                updateChatbotState(setState, mensajeResumen);

                // Mensaje con las opciones de confirmación
                const mensajeOpciones = createChatBotMessage(
                    "¿Deseas continuar con la venta?",
                    {widget: "widgetOpcionesConfirmarSeguirVenta", payload: datos}
                );
                updateChatbotState(setState, mensajeOpciones);
            } else {
                setVentaState({etapa: "curpCliente", datos});
                const mensajeEditarCURP = createChatBotMessage(
                    "Por favor, ingresa nuevamente la CURP."
                );
                updateChatbotState(setState, mensajeEditarCURP);
            }
            break;

        case "confirmarDatos":
            if (userMessage.toLowerCase() === "sí") {
                // Procedemos a solicitar la INE
                setVentaState({etapa: "subirINE", datos});
                const mensajeINE = createChatBotMessage(
                    "Por favor, sube la INE (archivo).",
                    {widget: "widgetSubirArchivo"}
                );
                updateChatbotState(setState, mensajeINE);
            } else if (userMessage.toLowerCase() === "no, editar") {
                // Se cancela el proceso
                setVentaState({etapa: null, datos});
                const mensajeCancelado = createChatBotMessage(
                    "Proceso cancelado. Puedes iniciar de nuevo si lo deseas."
                );
                updateChatbotState(setState, mensajeCancelado);
            } else if (userMessage.toLowerCase() === "guardar en prospectos") {
                // Se llama a una función pendiente para guardar en prospectos
                // guardarEnProspectos(datos, setState, createChatBotMessage);
                setVentaState({etapa: null, datos});
                const mensajeGuardado = createChatBotMessage(
                    "Los datos han sido guardados en prospectos No.Folio:A1234."
                );
                updateChatbotState(setState, mensajeGuardado);
            } else {
                const mensajeOpcionNoValida = createChatBotMessage(
                    "Opción no reconocida. Por favor, selecciona una opción."
                );
                updateChatbotState(setState, mensajeOpcionNoValida);
            }
            break;

        case "subirINE":
            // Se asume que el mensaje contiene el nombre del archivo seleccionado
            const nuevosDatosINE = {...datos, ine: userMessage};
            setVentaState({etapa: "subirComprobante", datos: nuevosDatosINE});
            const mensajeComprobante = createChatBotMessage(
                "Por favor, sube el comprobante de domicilio (archivo).",
                {widget: "widgetSubirArchivo"}
            );
            updateChatbotState(setState, mensajeComprobante);
            break;

        case "subirComprobante":
            // Guardamos el comprobante
            const nuevosDatosComp = {...datos, comprobante: userMessage};
            setVentaState({etapa: "insertarBase", datos: nuevosDatosComp});
            const mensajeInsertar = createChatBotMessage(
                "Insertando datos en la base de datos..."
            );
            updateChatbotState(setState, mensajeInsertar);
            // Aquí se llamaría a la función de inserción (pendiente de implementación)
            // insertarClienteEnDB(nuevosDatosComp, setState, createChatBotMessage).then((cuenta) => { ... });
            // Simulamos la inserción y pasamos a la selección de fecha
            setTimeout(() => {
                setVentaState({etapa: "seleccionarFecha", datos: nuevosDatosComp});
                const mensajeFechas = createChatBotMessage(
                    "Tenemos las siguientes fechas disponibles para la instalación:",
                    {widget: "widgetSeleccionFecha", payload: ["2025-02-15", "2025-02-16", "2025-02-17"]}
                );
                updateChatbotState(setState, mensajeFechas);
            }, 1000);
            break;

        case "seleccionarFecha":
            if (userMessage.startsWith("fecha:")) {
                const fechaSeleccionada = userMessage.replace("fecha:", "").trim();
                const nuevosDatosFecha = {...datos, fecha_instalacion: fechaSeleccionada};
                setVentaState({etapa: "confirmarFecha", datos: nuevosDatosFecha});
                const mensajeFechaConfirmada = createChatBotMessage(
                    `Has seleccionado la fecha ${fechaSeleccionada}. Confirmando instalación...`
                );
                updateChatbotState(setState, mensajeFechaConfirmada);
                // Simulamos la generación del número de cuenta
                setTimeout(() => {
                    const cuentaGenerada = "65432150"; // Número de cuenta de ejemplo
                    const mensajeCuenta = createChatBotMessage(
                        `La instalación ha sido confirmada. Tu número de cuenta es: ${cuentaGenerada}`
                    );
                    updateChatbotState(setState, mensajeCuenta);
                    setVentaState({etapa: null, datos: nuevosDatosFecha});
                }, 1000);
            }
            break;

        default:
            const mensajeError = createChatBotMessage(
                "Lo siento, no entendí tu respuesta. ¿Podrías repetirlo?"
            );
            updateChatbotState(setState, mensajeError);
            break;
    }
};
